import * as $ from 'jquery';

import { isJQueryComponentPlugin, JQueryComponentPlugin } from './custom-component-types';

function doInitComponents($root: JQuery): void {
  if ($.fn.iwNestedInput) {
    $root.iwNestedInput();
  }
  if ($.fn.iwOtherField) {
    $root.iwOtherField();
  }
  if ($.fn.iwSelectAll){
    $root.iwSelectAll();
  }

  // IMPORTANT: iwTimeInput and iwTimeSelector must be initialized before iwTimeRange, otherwise iwTimeRange will break
  //            since it will be looking for component instances that won't exist yet
  if ($.fn.iwTimeInput) {
    $root.iwTimeInput();
  }
  if ($.fn.iwTimeSelector) {
    $root.iwTimeSelector();
  }

  // IMPORTANT: iwTimeRange must be initialized before iwTimeRangeDisplay, otherwise iwTimeRangeDisplay will break
  //            since it will be looking for component instances that won't exist yet
  if ($.fn.iwTimeRange) {
    $root.iwTimeRange();
  }
  if ($.fn.iwTimeRangeDisplay) {
    $root.iwTimeRangeDisplay();
  }
}

function getOverloadArgs(
  $rootOrComponent: JQuery | JQueryComponentPlugin,
  components: JQueryComponentPlugin[],
): [JQuery | undefined, JQueryComponentPlugin[]] {
  if (isJQueryComponentPlugin($rootOrComponent)) {
    components.unshift($rootOrComponent);
    return [undefined, components];
  }
  return [$rootOrComponent, components];
}

/**
 * Calls {@link CustomComponent.loadPlugin} on each of the specified components, and initializes any
 * available plugins on the document's <body> element after page load.
 */
export function initComponents(...components: JQueryComponentPlugin[]): void

/**
 * Calls {@link CustomComponent.loadPlugin} on each of the specified components, and immediately initializes
 * any available plugins on $root.
 */
export function initComponents($root: JQuery, ...components: JQueryComponentPlugin[]): void
export function initComponents($rootOrComponent?: JQuery | JQueryComponentPlugin, ...components: JQueryComponentPlugin[]): void {
  // handle function overloads
  const [$root, allComponents] = getOverloadArgs($rootOrComponent, components);

  for (const component of allComponents) {
    component.loadPlugin();
  }

  if ($root) {
    doInitComponents($root);
  } else {
    $(() => doInitComponents($('body')));
  }
}
